import { Control } from '@/gen/inventory/v1/control_service_pb'

import { isUnvalidatedControlStatus, scoresAsValidatedControlStatus } from '@/lib/control-status'
import { ControlImpact, getImpactFromWeight } from '@/lib/risk/control-impact'

export const groupControlsByImpact = (controls: Control[]) => {
  return controls.reduce(
    (acc, control) => {
      const weight = control.controlWeight

      if (scoresAsValidatedControlStatus(control.status)) {
        acc.validated.controls.push(control)
        acc.validated.weight += weight
      } else if (isUnvalidatedControlStatus(control.status)) {
        const impact = getImpactFromWeight(weight)
        acc[impact].controls.push(control)
        acc[impact].weight += weight
      }

      return acc
    },
    {
      [ControlImpact.CRITICAL]: {
        controls: [] as Control[],
        weight: 0,
        type: 'unvalidated' as const,
      },
      [ControlImpact.MEDIUM]: {
        controls: [] as Control[],
        weight: 0,
        type: 'unvalidated' as const,
      },
      [ControlImpact.LOW]: {
        controls: [] as Control[],
        weight: 0,
        type: 'unvalidated' as const,
      },
      validated: { controls: [] as Control[], weight: 0, type: 'validated' as const },
    },
  )
}

export type GroupedControlsByImpact = ReturnType<typeof groupControlsByImpact>
